export const dictRuStep1 = {
  CalcTitle: 'Здесь вы можете:',
  MakeListItem1: 'Рассчитать стоимость и срок доставки',
  MakeListItem2: 'Вызвать курьера онлайн',
  MakeListItem3: 'Отправить груз из офиса DHL',
  CalcResultTitle: 'Выберите оптимальный способ отправления',
  Calculate: 'Рассчитать',
  CalculateRates: 'Рассчитать тариф',
  CountryName: 'Россия',
  Country: 'Страна',
  City: 'Город',
  Postcode: 'Индекс',
  CountryOnlyError: 'Создание отправления возможно только из РФ',
  CountryNoAccess: 'На текущий момент отправка из данной страны недоступна',
  CountryNoAccessTo: 'Отправка возможна только в Россию',
  GetRates: 'Рассчитать стоимость доставки',
  PickupFrom: 'Откуда отправить?',
  DeliveryTo: 'Куда доставить?',
  SendingWhat: 'Что вы отправляете?',
  PickUpTime: 'Когда отправить?',
  Date: 'Дата',
  Time: 'Время',
  TimeFrom: 'с',
  timeTo: 'до',
  CountryFrom: 'Отправка возможна только из России',
  CountryTo: 'Выберите страну получателя из выпадающего списка',
  CountriesFrom: 'Выберите страну отправителя из выпадающего списка',
  CountryToRUErrorMessage: 'На текущий момент доставка по России недоступна',
  CountryToUAErrorMessage:
    'Доставка грузов и документов из России в выбранную страну в настоящее время недоступна',
  CountryToBYErrorMessage:
    'Доставка грузов и документов из России в выбранную страну в настоящее время недоступна',
  PostalCodeFrom:
    'Выберите и/или проверьте индекс, соответствующий адресу отправителя',
  PostalCodeTo:
    'Выберите и/или проверьте индекс, соответствующий адресу получателя',
  OnlyRf: 'Отправка возможна только из России',
  CountryPlaceholder: 'Введите страну',
  CityOrPostalCode: 'Укажите город или индекс',
  CityPlaceholder: 'Введите город',
  PostcodePlaceholder: 'Введите индекс',
  nothingText: 'Простите, по вашему запросу ничего не найдено',
  addPiece: 'Добавить груз',
  Document: 'Документ',
  DocumentType: 'Тип груза: Бумажные листы любого формата',
  Item: 'Груз',
  ItemType: 'Тип груза: Груз',
  PieceWeight: 'Вес',
  PieceHeight: 'Высота',
  PieceDepth: 'Длина',
  PieceLength: 'Длина',
  PieceWidth: 'Ширина',
  PieceWeightSI: 'Вес груза (кг)',
  PieceDimensions: 'Габариты',
  PieceDimensionsSI: 'Габариты, (см)',
  PieceDimensionsDesc: 'В любой последовательности',
  Cancel: 'Отмена',
  Save: 'Готово',
  Hint: 'Подсказка',
  Show: 'Подробности',
  Hide: 'Скрыть',
  PieceDimension: 'Габариты',
  Service_Min_Weight: 'Минимальный оплачиваемый вес одного места',
  Service_Max_Weight: 'Максимальный вес одного места',
  InputRequired: 'Необходимо заполнить все размеры',
  IntegerDims: 'Габариты — только целые числа',
  InputMinWeightExceeded: 'Минимально допустимый размер',
  InputMaxExceeded: 'Максимально допустимые размеры - 120x80x80см',
  PickUpNoAvailableTimeTitle: 'Пожалуйста, выберите другой день.',
  PickUpNoAvailableTime:
    'К сожалению, вызов курьера не может быть осуществлен в указанный день. Возможно, на данный момент больше не осталось свободных интервалов для вызова курьера или выбранное направление не обслуживается в эту дату. Для отправки груза необходимо выбрать другой день',
  Or: 'или',
  ChooseOtherOptions: 'выбрать другую опцию отправки',
  PopularMethod: 'Популярный способ',
  ShipmentTypeDelieveryDate: 'Доставка ожидается:',
  ShipmentPlannedDeliveryTime: 'Планируемый срок доставки:',
  ShipmentPlannedDays:
    '0 рабочих дней | {n} рабочий день | {n} рабочих дня | {n} рабочих дней',
  ShipmentTypeNeededAction: 'Необходимые действия',
  ShipmentTypePayment: 'Способы оплаты',
  ShipmentTypeCash: 'Наличными (Оплата только отправителем)',
  ShipmentTypeCardOnline:
    'Банковская карта онлайн (Возможна оплата отправителем, получателем или третьим лицом)',
  ShipmentTypeWalkCard: 'Банковская карта - в офисе DHL',
  ShipmentTypeCardTerminal:
    'Банковская карта - терминал курьера (Оплата только отправителем)',
  ShipmentTypeDetails: 'Другие детали отправки',
  ShipmentTypeDetailsDesc:
    'Какие грузы не могут быть приняты к транспортировке, возможные причины задержек и т.д.',
  ShipmentTypeDetailsDescLink: 'Подробнее',
  ShipmentTypeVisit: 'Поездка до ближайшего офиса',
  ShipmentTypePrintAwb: 'Подготовка и распечатка накладной',
  ShipmentTypePrintAwbByShipper:
    'Отправителю подготовить и распечатать накладную',
  ShipmentTypePrintAwbForOffice: 'Подготовка и распечатка накладной',
  ShipmentTypePrintAwbForOfficePreparation: 'Подготовка накладной',
  ShipmentTypePrintAwbForOfficeNoPrint: 'Распечатка накладной не обязательна',
  ShipmentTypeQuoteIsValid:
    'Цена действительна при оформлении накладной прямо сейчас',
  ShipmentTypeWalkTitle: 'Отправить из офиса DHL',
  ShipmentTypeWalkPriceDesc:
    'Специальная цена действительна <b>при оформлении накладной на сайте онлайн</b> и отправке из офиса DHL',
  ShipmentTypeWalkProceed: 'Оформить',
  ShipmentTypeWalkConvenient: 'Самый экономичный вариант',
  ShipmentTypeWalkAffordable:
    'Подходит для отправки документов, а также малогабаритных и легких грузов',
  ShipmentTypeWalkDropTime:
    'Экономия времени – нет необходимости ждать курьера, просто сдайте ваш груз в ближайшем отделении',
  ShipmentTypeClickTitle: 'Вызвать курьера онлайн',
  ShipmentTypeClickBalance: 'Отличный баланс цены и удобства',
  ShipmentTypeClickFast:
    'Не нужно никуда идти, оформите все онлайн и ожидайте курьера',
  ShipmentTypeClickTime: 'Идеально для тех, кто ценит свое время ',
  ShipmentTypeClickPriceDesc:
    '<div>Специальная цена действительна при оформлении заказа и вызове курьера онлайн.</div><div>Необходимо <b>самостоятельно распечатать накладную</b>.</div>',
  ShipmentTypeClickBook: 'Онлайн-заявка',
  ShipmentTypePhoneTypeTitle: 'Вызвать курьера по телефону',
  ShipmentTypePhoneTypeEasy:
    'Удобно и подробно: оператор ответит на все ваши вопросы',
  ShipmentTypePhoneTypeOperator:
    'Идеально для тех, кому привычнее получать консультацию специалиста по телефону',
  ShipmentTypePhoneTypeConsultant:
    'Помощь с оформлением таможенных документов, консультации по нестандартному грузу',
  ShipmentTypePhoneTypePrieceDescr:
    'Цена действительна при вызове курьера по телефону',
  ShipmentTypeWait: 'Ожидание курьера до ',
  ShipmentTypeWaitFromAbroad:
    'Дождаться звонка отправителю для согласования даты и времени приема груза (до 8 рабочих часов)',
  ShipmentTypeDiscount: 'Скидка',
  CallCourierNow: 'Звонок',
  CallYourself: 'Или позвоните самостоятельно',
  Back: 'Назад',
  ShipmentTypeModalTitle:
    'Определите тип вашего вложения согласно требованиям страны получателя',
  ShipmentTypeModalDocuments: 'Принимаются как документы',
  ShipmentTypeModalNonDocuments: 'Принимаются как грузы',
  FillingInternationalNonDoc: 'Международная отправка грузов',
  FillingInternationalNonDocDesc:
    'Для отправки вашего груза необходимо оформить ' +
    'сопроводительные документы для таможенного декларирования. Чтобы получить консультацию, ' +
    'позвоните по номеру: ',
  FillingInternationalNonDocDescContinue:
    'После получения консультации продолжите оформление, нажав кнопку «ОК»',
  ShipmentDetailed: 'Подробнее',
  RestrictedTitle: 'Ограничения по перевозке грузов*',
  Responsibility:
    'Компания DHL берет на себя ответственность по доставке вашего груза. Однако по некоторым существующим законам,' +
    'а также в связи с мерами предосторожности и безопасности нижеперечисленные грузы не принимаются к перевозке или принимаются с ограничениями.',
  ProhibitedItems: 'Prohibited - запрещенные к перевозке грузы',
  RestrictedItems: 'Restricted - ограниченные к перевозке грузы',
  Animals: 'Животные (включая млекопитающих, рептилий, пауков, рыб и птиц).',
  Ashes:
    'Человеческие останки, прах в любой форме (включая человеческие эмбрионы, плаценту и прах, оформленный в ювелирные украшения).',
  Metal:
    'Драгоценные металлы и их сплавы (в слитках, монетах и пр.).' +
    'Драгоценные и полудрагоценные камни. Изделия из драгоценных металлов и их сплавов, драгоценных и полудрагоценных камней.',
  Cash: 'Наличные деньги (банкноты, монеты).',
  Firearms:
    'Предметы военного назначения: огнестрельное и холодное оружие, готовое к применению по назначению; взрывчатые вещества; боеприпасы; снаряды; патроны; подрывные средства, содержащие стойкие при хранении и транспортировке вещества и т.д.; части, механизмы огнестрельного оружия, аксессуары (прицел, спусковой механизм, болты и гайки, крепления, прицелы, приборы ночного видения, приклады, глушители, фонари, магазины, глушители вспышки и демаскирующие устройства и т.д.); иные предметы военного назначения, подлежащие контролю/лицензированию (предметы, «разработанные или модифицированные для военного использования», а именно: запасные части для танков и зенитных ракет, пульты управления, навигационное оборудование, блоки управления, счетчики боеприпасов, прибор управления стрельбой, датчики приборной скорости, запасные части и компоненты, разработанные или модифицированные для использования в военных целях, запасные части или оборудование для самолетов и вертолетов, разработанные или модифицированные для использования в военных целях и т.д.).',
  Illegal:
    'Слоновая кость и товары, запрещенные к легальному ввозу/вывозу в той или иной стране и/или по всему миру (например, порнография, пиратские копии, наркотики (героин, кокаин, фентанил и другие химикаты, которые сигнализируют о производстве наркотиков),' +
    'контрафактная продукция, а также курительные смеси, в состав которых входит один из следующих ингредиентов: шалфей предсказателей (Salvia divinorum),' +
    'гавайская роза (Argyreia nervosa), голубой лотос (Nymphaea caerulea).',
  Antiques:
    'Антиквариат и произведения искусства (с повышенной ответственностью и без). Независимо от стоимости, если на груз приобретается повышенная ответственность, нужно заранее предоставить независимую экспертную оценку стоимости.',
  Banderols: 'Акцизные марки и непогашенные почтовые марки.',
  Cigarettes:
    'Табачное сырье и изделия из табака (сигареты, сигары, сигариллы, курительный и трубочный табак), электронные сигареты.',
  DangerousGoods:
    'Электрошоковое оборудование, электрошоковые пистолеты, электрошокеры либо иные предметы, способные производить электрический разряд с целью причинить вред, ранить или временно вывести из строя (напрямую или косвенно предназначенные для этих целей).',
  NegotiableInstruments:
    'Платежные документы/эквиваленты денежных средств в форме на предъявителя: активированные SIМ-карты, неименные кредитные и дебетовые карты, чеки на предъявителя, неименные билеты на различные мероприятия, лотерейные билеты, дорожные чеки, предоплатные телефонные карты, ваучеры, жетоны, являющиеся эквивалентом денежных средств, денежные переводы, подарочные сертификаты.',
  Furs: 'Меха, слоновая кость и изделия из них.',
  Jewellery:
    'Бижутерия без драгоценных и полудрагоценных металлов и камней для доставки внутри страны. Бижутерия без драгоценных и полудрагоценных металлов и камней для международной доставки, если стоимость одного изделия не более 5ООО евро**, партии - не более 1ОО ООО евро**, не является ограниченной к перевозке и принимается в соответствии с таможенными правилами РФ и правилами компании DHL.',
  Watches:
    'Наручные часы без драгоценных металлов стоимостью более 10 000 евро** за одно изделие для юридических лиц и стоимостью более 10 000 евро** за одно изделие/весь груз в адрес физических лиц.***',
  ToyGuns: 'Игрушечные, пневматические пистолеты.',
  ReplicaFirearms:
    'Имитация огнестрельного и холодного оружия, муляжи снарядов, патронов, боеприпасов. Предметы, которые потенциально могут быть использованы в качестве оружия, но это не является их прямым назначением (кухонные ножи), в том числе декоративные изделия (сабли, шпаги, и т. д.), принимаются к пересылке без ограничений, но отправитель должен приложить справку/сертификат/паспорт (с печатью), что данный предмет не является холодным оружием.***',
  RestrictedNotice1:
    'По всем вопросам, связанным с ограничениями по перевозке грузов, в том числе документов, а также таможенным декларированием, обращайтесь в ближайший офис DHL.',
  RestrictedNotice2: 'Либо в рублевом эквиваленте по курсу ЦБ РФ.',
  RestrictedNotice3: 'Товары запрещены для импорта в Россию.',
  RestrictedNotice4:
    'Для получения дополнительной информации о принимаемых дебетовых и кредитных картах, пожалуйста, свяжитесь с ближайшим офисом DHL.',
  CorpClientTips:
    'Если вы являетесь корпоративным клиентом и у вас есть клиентский счет DHL – рассчитайте тариф',
  CorpClientTipsLinkText: 'здесь',
  CorpClientTipsLink: 'https://mydhl.express.dhl/ru/ru/auth/login.html',
  CorpClientTipsHint:
    'Потребуется ввести логин и пароль для доступа в личный кабинет',
  InvoiceCreate: 'Создать инвойс',
  InvoiceHad: 'У меня есть инвойс',
  LinkDeliveryAbroad: 'Доставка за границу для интернет-магазинов',
  InfoMessage:
    'Уважаемый клиент! После расчета тарифа, пожалуйста, обратитесь к онлайн-консультанту или в отдел по работе с клиентами для уточнения возможности отправки вашего груза: тел. ',
  PaymentMethodsMessage:
    'Для данного направления нет доступных вариантов оплаты. Пожалуйста, обратитесь в контактный центр DHL для уточнения деталей.',
};

export default {
  dictRuStep1,
};
